import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const Navigation = ({ links = [], contentLink = null }) => {
  let menuRef = React.createRef();
  let mobileSearch = React.createRef();
  let textInput = React.createRef();
  let currentLang = window.location.pathname.split('/')[1];
  function toggleMenu() {
    menuRef.current.classList.toggle('navbar__menu--show');
  }

  function toggleSearch() {
    mobileSearch.current.classList.toggle('in-the-open');
  }

  function search() {
    if (!currentLang) currentLang = 'en';

    window.location.href =
      '/' + currentLang + '/search-result?q=' + textInput.current.value;
  }

  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;
  const hasMobileOnly =
    (contentLink != null && contentLink.mobileOnly) ||
    (contentLink != null && contentLink.extraInfo === 'mobileOnly')
      ? 'show-on-mobile-menu-only'
      : '';

  const megaItems = links.filter(
    link => link.links !== undefined && link.links.length !== 0,
  );
  const useMegaMenu = contentLink !== null && megaItems.length > 0;

  return (
    <Fragment>
      {!contentLink ? (
        // Header Icon.
        <Fragment>
          <a
            className="navbar__link--block navbar__icon--menu navbar__icon"
            onClick={toggleMenu}
          ></a>
        </Fragment>
      ) : (
        // Menu Item.
        <Fragment>
          <a
            className={`navbar__link ${hasChildrenClass || ''} ${
              additionClass || ''
            } ${hasMobileOnly}`}
            href={contentLink.url || '#'}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}
      {links.length > 0 && useMegaMenu && (
        <ul className={`navbar__menu`} ref={menuRef}>
          <div
            className={`mega__menu`}
            style={{ gridTemplateColumns: `repeat(${megaItems.length}, 1fr)` }}
          >
            <div className="navbar__menu-header">
              {!contentLink ? (
                <span
                  className="navbar__icon navbar__icon--close"
                  onClick={toggleMenu}
                ></span>
              ) : (
                <Fragment>
                  <i
                    className="navbar__icon--caret-left navbar__icon"
                    onClick={toggleMenu}
                  ></i>
                  <span
                    className="navbar__title"
                    onClick={toggleMenu}
                    dangerouslySetInnerHTML={{ __html: contentLink.name }}
                  ></span>
                </Fragment>
              )}
            </div>
            {links.length > 0 &&
              links.map((link, i) => (
                <li
                  className={`navbar__item ${
                    link.mobileOnly == undefined &&
                    link.extraInfo !== 'mobileOnly'
                      ? ''
                      : 'show-on-mobile-menu-only'
                  }`}
                  key={`${link.name}-${i}`}
                >
                  <Navigation links={link.links} contentLink={link} />
                </li>
              ))}
            <li className="navbar__item show-on-mobile-menu-only">
              <span className="navbar__title" onClick={toggleSearch}>
                Search
              </span>

              <div className="mobile-search" ref={mobileSearch}>
                <input
                  className="input"
                  type="search"
                  placeholder="Search"
                  ref={textInput}
                />
                <button className="button" type="submit" onClick={search}>
                  <i className="icon"></i>
                  <span className="title">Search</span>
                </button>
              </div>
            </li>
          </div>
        </ul>
      )}
      {links.length > 0 && !useMegaMenu && (
        <ul className={`navbar__menu`} ref={menuRef}>
          <div className="navbar__menu-header">
            {!contentLink ? (
              <span
                className="navbar__icon navbar__icon--close"
                onClick={toggleMenu}
              ></span>
            ) : (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                ></i>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{ __html: contentLink.name }}
                ></span>
              </Fragment>
            )}
          </div>
          {links.length > 0 &&
            links.map((link, i) =>
              !link.name ? null : (
                <li
                  className={`navbar__item ${
                    link.mobileOnly == undefined &&
                    link.extraInfo !== 'mobileOnly'
                      ? ''
                      : 'show-on-mobile-menu-only'
                  }`}
                  key={`${link.name}-${i}`}
                >
                  <Navigation
                    links={link.links}
                    contentLink={link}
                    megaMenu={link.links !== undefined && link.links.length > 0}
                  />
                </li>
              ),
            )}
          <li className="navbar__item show-on-mobile-menu-only">
            <span className="navbar__title" onClick={toggleSearch}>
              Search
            </span>

            <div className="mobile-search" ref={mobileSearch}>
              <input
                className="input"
                type="search"
                placeholder="Search"
                ref={textInput}
              />
              <button className="button" type="submit" onClick={search}>
                <i className="icon"></i>
                <span className="title">Search</span>
              </button>
            </div>
          </li>
        </ul>
      )}
    </Fragment>
  );
};

export default Navigation;
